declare global {
  interface Array<T> {
    split(fn: (it: T) => boolean): [Array<T>, Array<T>]
    filterNotNull() : Array<NonNullable<T>>
  }
}

Array.prototype.split = function <T>(this: Array<T>, fn: (it: T) => boolean): [Array<T>, Array<T>] {
  const first: T[] = []
  const second: T[]= []
  this.forEach(it => {
    fn(it) ? first.push(it) : second.push(it)
  })
  return [first, second]
};

Array.prototype.filterNotNull = function <T>(this: Array<T>): Array<NonNullable<T>> {
    return this.filter((it): it is NonNullable<T> => it != null)
}

export default {}
